import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { loanService } from '../../services/loanService';

export const useGetLoanPaymentSchedule = fundraisingId => {
  return useQuery({
    queryKey: [QUERY_KEYS.loan.payment_schedule, fundraisingId],
    queryFn: () =>
      loanService.paymentSchedule(fundraisingId).then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        return null;
      }),
  });
};
